<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="btn-container clearfix mb-10">
        <div class="left-opt fl">
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
        </div>
<!--        取消刷新-->
<!--        <div class="rigth-opt fr">-->
<!--          <span class="svg-icon cursor mr-10"  @click="handleCommand('refresh')">-->
<!--            <i class="icon-tubiao-27 iconfont"/>-->
<!--          </span>-->
<!--          <span class="svg-icon cursor" @click="setColumnVisible=true">-->
<!--            <i class="icon-tubiao-28 iconfont"/>-->
<!--          </span>-->
<!--        </div>-->
      </div>
      <el-table
        v-loading="listLoading"
        :data="list"
        border
        row-key="id"
        style="width: 100%"
        :lazy="true"
        :load="handleLoadLazy"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      >
        <el-table-column
          v-for="(column, index) of columnData"
          :key="column.fieldKey + index"
          :prop="JSON.stringify(column)"
          :label="column.fieldName"
          show-overflow-tooltip
        >
          <template #default="{ row }" >
            <span>{{ row[column.fieldKey] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="t('table.actions')"
          align="center"
          min-width="140"
          class-name="fixed-width"
        >
          <template #default="{ row }">
            <el-link
              v-permission="{ pkey: `${permissionName}_ADD` }"
              href="javascript:void(0);"
              class="mr-10"
              type="primary"
              @click="handleCommand('addRow', row)"
            >
              {{ t("table.add") }}
            </el-link>
            <el-link
                v-permission="{ pkey: `${permissionName}_EDIT` }"
                href="javascript:void(0);"
                class="mr-10"
                type="primary"
                @click="handleCommand('edit', row)"
            >
                {{ t("table.edit") }}
            </el-link>
            <el-link
                v-permission="{ pkey: `${permissionName}_DELETE` }"
                href="javascript:void(0);"
                type="danger"
                @click="handleCommand('delete', row)"
            >
                {{ t("table.delete") }}
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="pathApi"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <CustomColumn
      v-if="setColumnVisible"
      :visible="setColumnVisible"
      :tabelField="columnAllData"
      :tableName="TableName"
      :checkList="columnCheckList"
      @update:visible="() => setColumnVisible = false"
      @submit="handleLoadColumn"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById } from '@/apis/Dictionary'
import { getSysAreaListByNo } from '@/apis/sysArea'
import { getTableColumnList } from '@/apis/tool'

import { SysAreaModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import CustomColumn from '@/components/common/CustomColumn.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Sysarea',
  components: {
    FormComponent,
    CustomColumn
  },
  setup() {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: TableName.TABLE_SYSAREA,
      permissionName: permissionName.SYSAREA,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,
      pathApi: 'sysArea',
      activeId: 0,
      superNo: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        page: 1,
        size: 10
      },
      dialogFormVisible: false,
      deptTop: {
        superNo: 0,
        no: 0,
        name: '顶级区域'
      },
      superNoOptions: [],
      maps: new Map(),
      refreshRow: {} as SysAreaModel,
      setColumnVisible: false,
      columnCheckList: [],
      columnData: [],

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate(dataMap.deptTop)
            break
          case 'addRow':
            dataMap.handleCreate(val)
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getSysAreaListByNo(0).then((res: any) => {
          dataMap.list = res
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleLoadLazy(tree: any, treeNode: any, resolve: any) {
        const parentId = tree.no
        dataMap.maps.set(parentId, { tree, treeNode, resolve })
        getSysAreaListByNo(tree.no).then((res: any) => {
          resolve(res)
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          page: 1,
          size: 20
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },
      handleCreate(row: any) {
        dataMap.activeId = 0
        dataMap.refreshRow = {
          ...row,
          superNo: row.superNo
        }
        dataMap.loadFormDataSlectOption(row)
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.refreshRow = row
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDetailById(dataMap.pathApi, row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey]
                if (field.fieldKey === 'superNo') {
                  field.option = [{
                    id: row.no,
                    name: row.name
                  }]
                }
              })
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        dataMap.refreshRow = row
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.pathApi, row.id).then(() => {
              dataMap.handleSubmit()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        // console.log('maps:', dataMap.maps)
        // console.log('refreshRow:', dataMap.refreshRow)
        const { tree, treeNode, resolve } = dataMap.maps.get(dataMap.refreshRow.superNo)
        // this.$set(this.$refs.table.store.states.lazyTreeNodeMap, parentId, [])
        dataMap.handleLoadLazy(tree, treeNode, resolve)
      },
      loadFormDataSlectOption(row: any) {
        dataMap.initFormData.forEach((item: any) => {
          item.formList.forEach((k: any) => {
            if (k.fieldKey === 'superNo') {
              k.value = row.no
              k.option = [{
                id: row.no,
                name: row.name
              }]
            }
          })
        })
      },
      handleLoadColumn() {
        getTableColumnList(dataMap.TableName).then((res: any) => {
          const requestData = (res && Array.isArray(res.fields) && res.fields.length) ? res.fields : []
          if (requestData.length) {
            const orderedFields: any[] = []
            const usedLocalIndices = new Set<number>()
            requestData.forEach((remoteField: any) => {
              let localIdx = -1
              if (typeof remoteField === 'object' && remoteField !== null) {
                localIdx = dataMap.columnAllData.findIndex(
                  (col: any, idx: number) =>
                    !usedLocalIndices.has(idx) &&
                    (col.fieldKey === remoteField.fieldKey || col.fieldName === remoteField.fieldName)
                )
              } else if (typeof remoteField === 'string') {
                localIdx = dataMap.columnAllData.findIndex(
                  (col: any, idx: number) =>
                    !usedLocalIndices.has(idx) &&
                    (col.fieldName === remoteField || col.fieldKey === remoteField)
                )
              }
              if (localIdx !== -1) {
                usedLocalIndices.add(localIdx)
                const localCol = dataMap.columnAllData[localIdx]
                orderedFields.push({
                  ...localCol,
                  isCheck: typeof remoteField === 'object' ? remoteField.isCheck !== false : true,
                  width: (typeof remoteField === 'object' ? remoteField.width : 0) || localCol.width
                })
              }
            })
            dataMap.columnAllData.forEach((localCol: any, idx: number) => {
              if (!usedLocalIndices.has(idx)) {
                orderedFields.push({ ...localCol, isCheck: true })
              }
            })
            dataMap.columnAllData = orderedFields
            dataMap.columnData = orderedFields.filter((item: any) => item.isCheck !== false)
            dataMap.columnCheckList = dataMap.columnData
          } else {
            dataMap.columnData = dataMap.columnAllData
            dataMap.columnCheckList = dataMap.columnAllData
          }
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
          dataMap.columnData = dataMap.columnAllData
          dataMap.columnCheckList = dataMap.columnAllData
        })
      }
    })
    onMounted(() => {
      dataMap.handleLoadColumn()
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">

</style>
